import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import { GiCandleFlame } from "react-icons/gi";
import { FaPhoneAlt } from "react-icons/fa";
class Header extends React.Component {
  render() {
    return (
      <div className="headercontainer">
        <div>
          <a href="#" className="logo1">
            {" "}
            <GiCandleFlame />
            <span className="logoportfolio">Portfolio</span>
          </a>
        </div>
        <div>
          <ul className="headnav">
            <li>
              <a href="#" className="headnav1">
                Home
              </a>
            </li>
            <li>
              <a href="#education" className="headnav1">
                Education
              </a>
            </li>
            <li>
              <a href="#skillsid" className="headnav1">
                Skills
              </a>
            </li>
            <li>
              <a href="#projectsid" className="headnav1">
                Projects
              </a>
            </li>
            <li>
              <a href="#contactid" className="headnav1">
                Contact
              </a>
            </li>
            <li className="headnav2">
              <FaPhoneAlt />
              {""}
              <span className="phnno">8122181887</span>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
export default Header;
